import React from 'react';

import { Accordion, Col, Container, Row } from 'react-bootstrap';

import { SummaryLine, SummaryLineBullet } from "../../data";

import "./SummaryBox.css";

interface SummaryBoxProps {
    summaryLines: SummaryLine[]
};

const SummaryBox = ({ 
    summaryLines
} : SummaryBoxProps): JSX.Element => {
    const isLarge = window.innerWidth >= 992;
    const defaultActiveKey = isLarge ? '0' : null;
    
    return (
        <Accordion id="summary-dropdown" className='pt-3 px-3' defaultActiveKey={defaultActiveKey}>
            <Accordion.Item eventKey="0">
                <Accordion.Header>Project Details</Accordion.Header>
                <Accordion.Body className='p-0'>
                    <Container>
                        <Row className='summaryBox d-flex justify-content-center p-3'>
                            <Col xs={12} lg={6}>
                                {summaryLines && summaryLines.slice(0, Math.ceil(summaryLines.length / 2)).map((line, index) => (
                                    <SummaryBoxLine key={index} title={line.title} summary={line.description} bullets={line.bullets} />
                                ))}
                            </Col>
                            <Col xs={12} lg={6}>
                                {summaryLines && summaryLines.slice(Math.ceil(summaryLines.length / 2)).map((line, index) => (
                                    <SummaryBoxLine key={index} title={line.title} summary={line.description} bullets={line.bullets} />
                                ))}
                            </Col>
                        </Row>
                    </Container>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

interface SummaryBoxLineProps {
    title: string,
    summary?: string,
    bullets?: SummaryLineBullet[],
};

const SummaryBoxLine = ({
    title,
    summary = '',
    bullets = []
} : SummaryBoxLineProps): JSX.Element => {
    if (summary === '' && bullets.length === 0) return <></>;

    return (
        <>
            <p className='lineHeader'>{title}</p>
            {summary && <p>{summary}</p>}
            {bullets.length > 0 && (
                <ul>
                    {bullets.map((item) => <li>
                        {item.link ? <a href={item.link} target="_blank" rel="noopener noreferrer">{item.text}</a> : item.text}
                    </li>)}
                </ul>
            )}
        </>
    );
}

export { SummaryBox };